import React from 'react'
import ReactDOM from 'react-dom'
import { useSelector } from 'react-redux'
import ScrollbarSize from 'react-scrollbar-size'

import { getColorMode, COLORMODES } from 'data/userPreferences/selectors'

export const LS_COLOR_MODE_KEY = 'slite-color-mode'

function ScrollbarColorSync() {
  const [hasCustomScrollbars, setHasCustomScrollbar] = React.useState(false)

  const onScrollbarMeasurements = React.useCallback(({ scrollbarWidth }) => {
    // Only set custom scrollbar if OS has always visible scrollbars
    setHasCustomScrollbar(scrollbarWidth > 0)
  }, [])

  React.useEffect(
    () => {
      if (hasCustomScrollbars) {
        document.body.classList.add('slite-scrollbar')
      } else {
        document.body.classList.remove('slite-scrollbar')
      }
    },
    [hasCustomScrollbars]
  )

  return (
    <ScrollbarSize
      onLoad={onScrollbarMeasurements}
      onChange={onScrollbarMeasurements}
    />
  )
}

export default React.memo(function ColorModeSync() {
  const colorMode = useSelector(getColorMode)

  React.useEffect(
    () => {
      if (!colorMode) {
        return
      }
      localStorage.setItem(LS_COLOR_MODE_KEY, colorMode)
      if (colorMode === COLORMODES.DARK) {
        document.body.classList.add('dark-mode')
      } else {
        document.body.classList.remove('dark-mode')
      }
    },
    [colorMode]
  )

  return ReactDOM.createPortal(
    <ScrollbarColorSync colorMode={colorMode} />,
    document.body
  )
})
